import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { SESSION_EXPIRED } from '../../actions/types';
import { getAccessToken } from '../auth';
import config from '../../assets/config';
import type { RootState } from '../../reduxTypes';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${config.apiUrl.dataServer}/api`,
  prepareHeaders: (headers) => {
    const accessToken = getAccessToken();
    if (accessToken) {
      headers.set('x-prerender-authorization', accessToken);
    }
    return headers;
  },
});

const baseQueryWith401: typeof rawBaseQuery = async (args, api, extraOptions) => {
  // Once the session is expired, fail fast with the same shape a real 401 would have —
  // no point hitting the server without credentials.
  if ((api.getState() as RootState).keycloak.sessionExpired) {
    return { error: { status: 401, data: 'Session expired' } };
  }
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    api.dispatch({ type: SESSION_EXPIRED });
  }
  return result;
};

export const restApiLegacy = createApi({
  baseQuery: baseQueryWith401,
  tagTypes: ['CachedPages', 'Subscription'],
  reducerPath: 'legacyApi',
  endpoints: () => ({}),
});
